import { useSimulationStore } from '@/store/simulationStore';
import { parseAddress } from '@/plc/address/parser';
import type { HMIDataBinding } from '@/hmi/model/types';

export function useHMILiveValue(binding: HMIDataBinding): number | boolean | null {
  return useSimulationStore(s => {
    void s.snapshot.cycle;
    const engine = s.engine;
    
    if (binding.type !== 'PLC' || !binding.address) {
      return null;
    }
    
    try {
      const addr = parseAddress(binding.address);
      if (addr) {
        const area = addr.area === 'I' ? engine.host.pi.inputs 
                   : addr.area === 'Q' ? engine.host.pi.outputs 
                   : engine.host.pi.memory;
                   
        if (addr.size === 'X') {
          return area.getBit(addr.byteOffset, addr.bitOffset);
        } else if (addr.size === 'B') {
          return area.getByte(addr.byteOffset);
        } else if (addr.size === 'W') {
          return area.getWord(addr.byteOffset);
        } else {
          return area.getDWord(addr.byteOffset);
        }
      }
    } catch {
      // ignore
    }
    
    return null;
  });
}
